import { render } from "./ButtonCancel.vue?vue&type=template&id=ce8d6f32&scoped=true"
import script from "./ButtonCancel.vue?vue&type=script&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&lang=js"

import "./ButtonCancel.vue?vue&type=style&index=0&id=ce8d6f32&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8d6f32"]])

export default __exports__